import type { Identifiers } from '@hyundai/shared-lib/edit';
import { DialogTag } from '@pixelgenau/ngx-dialog';

export interface EditTextDialogData {
    id: Identifiers;
    value: string;
}

export const EditTextDialogTag = new DialogTag<EditTextDialogData>(
    'edit-text-dialog',
    () => import('./edit-text.component'),
);
